import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Environment } from 'src/environment';

import { Customer, CustomerLocation } from '../../shared/models/shared.model';
import { LocationResponse } from '../models/customer-service.model';

@Injectable()
export class CustomerService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = `${this.env.API_BASE_URL}/service/customer-account-management/secure`;

  getCustomerById(id: number): Observable<Customer> {
    return this.http.get<Customer>(`${this.baseUrl}/customers/${id}`);
  }

  upsertCustomer(customer: Customer): Observable<Customer> {
    return this.http.post<Customer>(`${this.baseUrl}/customers`, customer, {});
  }

  getLocations(customerId: number): Observable<CustomerLocation[]> {
    return this.http
      .get<LocationResponse>(`${this.baseUrl}/customers/${customerId}/locations`)
      .pipe(
        map((response: LocationResponse) => response.locations),
        catchError((error: HttpErrorResponse) => throwError(error.status)),
      );
  }

  upsertLocation(customerId: number, location: CustomerLocation): Observable<CustomerLocation> {
    return this.http.post<CustomerLocation>(
      `${this.baseUrl}/customers/${customerId}/locations`,
      location,
      {},
    );
  }

  deleteLocation(id: number) {
    return this.http.delete(`${this.baseUrl}/locations/${id}`);
  }
}
